
    @switch ((error$ | async)) {
    @case (ERROR.required) {
    <ng-container i18n="@@error.required">Wert eingeben</ng-container>
    }
    @case (ERROR.requiredtrue) {
    <ng-container i18n="@@error.requiredtrue">Auswahl erforderlich</ng-container>
    }
    @case (ERROR.min) {
    <ng-container i18n="@@error.min">Wert zu niedrig</ng-container>
    }
    @case (ERROR.max) {
    <ng-container i18n="@@error.max">Wert zu hoch</ng-container>
    }
    @case (ERROR.email) {
    <ng-container i18n="@@error.email">ungültige Email Adresse</ng-container>
    }
    @case (ERROR.minLength) {
    <ng-container i18n="@@error.minlength">Eingabe fehlt oder ist zu kurz</ng-container>
    }
    @case (ERROR.maxLength) {
    <ng-container i18n="@@error.maxlength">Eingabe ist zu lang</ng-container>
    }
    @case (ERROR.pattern) {
    <ng-container i18n="@@error.pattern">gültigen Wert eingeben</ng-container>
    }
    @case (ERROR.dateFormat) {
    <ng-container i18n="@@error.dateFormat">das Datum ist ungültig</ng-container>
    }
    @case (ERROR.minDate) {
    <ng-container i18n="@@error.minDate">Datum zu früh</ng-container>
    }
    @case (ERROR.maxDate) {
    <ng-container i18n="@@error.maxDate">Datum zu spät</ng-container>
    }
    @case (ERROR.isInYear) {
    <ng-container i18n="@@error.isInYear">Datum nicht im Bearbeitungsjahr</ng-container>
    }
    @case (ERROR.matDatepickerFilter) {
    <ng-container i18n="@@error.matDatepickerFilter">matDatepickerFilter</ng-container>
    }
    @case (ERROR.phone) {
    <ng-container i18n="@@error.phone">gültige Telefonnummer eingeben</ng-container>
    }
    @case (ERROR.ahvNummer) {
    <ng-container i18n="@@error.ahvNummer">gültige AHV-Nummer (AHV13) eingeben</ng-container>
    }
    @case (ERROR.integer) {
    <ng-container i18n="@@error.integer">Ganzzahl eingeben</ng-container>
    }
    @case (ERROR.geschlechtAusgewaehlt) {
    <ng-container i18n="@@error.geschlechtAusgewaehlt">Geschlecht auswählen</ng-container>
    }
    @case (ERROR.invalidXMLZeichen) {
    <ng-container i18n="@@error.invalidXMLZeichen">ungültiges Zeichen für XML Export</ng-container>
    }
    @case (ERROR.UNBEKANNT) {
    <ng-container i18n="@@error.UNBEKANNT">Unerwarteter Fehler</ng-container>
    }
    }